export default {
  '操作日志': '操作日志',
  '请输入关键字': '请输入关键字',
  '删除选中': '删除选中',
  '请求方式': '请求方式',
  '状态': '状态',
  '搜索': '搜索',
  '清空': '清空',
  '启用': '启用',
  '禁用': '禁用',
  '操作': '操作',
  '详情': '详情',
  '删除': '删除',
  '日志详情': '日志详情',

  'ID': 'ID',
  '账号ID': '账号ID',
  '账号昵称': '账号昵称',
  '请求URL': '请求URL',
  '请求IP': '请求IP',
  '请求方法': '请求方式', // 请求方式的名称 跟上面的重复了 这里改为 请求方法
  '请求内容': '请求内容',
  '请求时间': '请求时间',
  'UA信息': 'UA信息',
  '激活状态': '激活状态',

  '确认要删除该日志吗？': '确认要删除该日志吗？',
  '确认要删除选中的日志吗？': '确认要删除选中的日志吗？',
  '请选择要删除的日志': '请选择要删除的日志',
  '确认要清空一个月之前的日志吗？': '确认要清空一个月之前的日志吗？'
}
